<template>
  <div class="dynamic-tables">
    <Breadcrumbs v-bind:breadcrumbs="breadcrumbs" />

    <Widget>
      <DataTable
        class="p-datatable-sm"
        :value="storageSystems"
        :paginator="true"
        :filters="filters"
        :loading="loading"
        :scrollable="true"
        scrollHeight="650px"
        :rows="1000"
        dataKey="id"
        :rowHover="true"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[25, 50, 100, 1000]"
        currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Einträgen"
      >
        <template #header>
          <div class="table-header">
            <div class="table-header-left">
              <h1 class="page-title">{{ $t('storageSystems') }}</h1>
            </div>
            <div class="table-header-right">
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText type="text" v-model="filters['global']" :placeholder="$t('search')" />
              </span>
              <div class="button-right">
                <router-link
                  class="btn btn-success mb-2 right"
                  :to="{ name: 'StorageSystemCreatePage' }"
                >
                  <i class="fa fa-plus-circle mr-2"></i>
                  {{ $t('storageSystemCreate') }}
                </router-link>
              </div>
            </div>
          </div>
        </template>
        <template #empty>
          {{ $t('no_data_found') }}
        </template>
        <template #loading>
          {{ $t('loading') }}
        </template>

        <Column field="number" header="#" sortable filterMatchMode="contains">
          <template #body="slotProps">
            <router-link
              :to="{
                name: 'StorageSystemEditPage',
                params: { storageSystemNumber: slotProps.data.number },
              }"
              >{{ slotProps.data.number.toString().padStart(4, '0') }}</router-link
            >
          </template>
          <template #filter>
            <InputText type="text" v-model="filters['number']" class="p-column-filter" />
          </template>
        </Column>

        <Column
          field="manufacturer"
          :header="$t('manufacturer')"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText type="text" v-model="filters['manufacturer']" class="p-column-filter" />
          </template>
        </Column>

        <Column field="type" :header="$t('type')" sortable filterMatchMode="contains">
          <template #filter>
            <InputText type="text" v-model="filters['type']" class="p-column-filter" />
          </template>
        </Column>

        <Column
          field="inverterDescription"
          :header="$t('inverter')"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText
              type="text"
              v-model="filters['inverterDescription']"
              class="p-column-filter"
            />
          </template>
        </Column>

        <Column
          field="batteryDescription"
          :header="$t('battery')"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText
              type="text"
              v-model="filters['batteryDescription']"
              class="p-column-filter"
            />
          </template>
        </Column>

        <Column
          field="energyFlowDirectionSensorDescription"
          :header="$t('energyFlowDirectionSensor')"
          sortable
          filterMatchMode="contains"
        >
          <template #filter>
            <InputText
              type="text"
              v-model="filters['energyFlowDirectionSensorDescription']"
              class="p-column-filter"
            />
          </template>
        </Column>
      </DataTable>
    </Widget>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Widget from '@/components/Widget/Widget';
import Breadcrumbs from '@/components/Breadcrumbs';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';

export default {
  name: 'StorageSystemsPage',
  components: {
    Breadcrumbs,
    DataTable,
    Widget,
    InputText,
    Column,
  },
  data() {
    return {
      loading: true,
      filters: {},
    };
  },
  computed: {
    ...mapGetters(['isLoading', 'getStorageSystems']),
    breadcrumbs() {
      return [{ name: 'Home', route: { name: 'home' } }, { name: this.$t('storageSystems') }];
    },
    storageSystems() {
      const storageSystems = [];
      this.getStorageSystems.map((storageSystem) => {
        if (storageSystem.inverter) {
          storageSystem.inverterDescription =
            storageSystem.inverter.manufacturer + ' ' + storageSystem.inverter.type;
        }
        if (storageSystem.battery) {
          storageSystem.batteryDescription =
            storageSystem.battery.manufacturer + ' ' + storageSystem.battery.type;
        }
        if (storageSystem.energyFlowDirectionSensor) {
          storageSystem.energyFlowDirectionSensorDescription =
            storageSystem.energyFlowDirectionSensor.manufacturer +
            ' ' +
            storageSystem.energyFlowDirectionSensor.type;
        }

        storageSystems.push(storageSystem);
      });

      return storageSystems;
    },
  },
  methods: {
    ...mapActions(['fetchStorageSystems']),
  },
  async created() {
    await this.fetchStorageSystems();
    this.loading = false;
  },
};
</script>

<style scoped lang="scss">
::v-deep .p-datatable .p-datatable-thead > tr > th:nth-child(1),
::v-deep .p-datatable .p-datatable-tbody > tr > td:nth-child(1) {
  width: 60px;
  text-align: center;
}
.table-header {
  display: flex;
  justify-content: space-between;
}
.table-header-left {
  display: flex;
  justify-content: flex-start;
}
.table-header-right {
  display: flex;
  justify-content: flex-end;
  column-gap: 1em;
}
</style>
